import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Upload,
  Form,
  Col,
  message,
  Tooltip,
  Typography,
  Modal,
} from 'antd';
import {
  CloseCircleOutlined,
  FileUnknownOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';

const getBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

const PicturesWall = ({
  rules,
  name,
  label,
  allowedExtensions,
  limitMB,
  multiple,
  disabled,
  tooltip,
  style,
}) => {
  const formInstance = Form.useFormInstance();
  const fileList = Form.useWatch(name, formInstance);
  const accept = !allowedExtensions.length ? '*/*' : allowedExtensions.map((e) => `.${e}`).join(',');
  const formats = allowedExtensions.join(', ').toUpperCase();
  const [preview, setPreview] = useState();

  useEffect(() => {
    if (!disabled) {
      formInstance.setFieldsValue({ [name]: [] });
    }
  }, []);

  const beforeUpload = (file, add) => {
    const isValidExt = !allowedExtensions.length
      || allowedExtensions.includes(file.name.split('.').pop().toLowerCase());

    const isLmt = (file.size / 1024 / 1024) < limitMB;
    if (!isLmt) message.warn(`Cada archivo no debe sobrepasar los ${limitMB}MB`);
    if (!isValidExt) message.warn(`Solo se admiten archivos en formato ${formats}`);

    if (isLmt && isValidExt) add();

    return false;
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      const _preview = await getBase64(file.originFileObj);
      setPreview({
        src: file.url || _preview,
        tutle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      });
    }
  };

  const handleChange = ({ fileList: fl }) => formInstance.setFieldsValue({ [name]: fl });

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={name}
          label={(
            <>
              <Typography.Text style={{ marginRight: 5 }}>{label}</Typography.Text>
              <Tooltip title={allowedExtensions.length && `Solo se admiten archivos en formato ${formats}`}>
                <FileUnknownOutlined style={{ marginLeft: 10 }} />
              </Tooltip>
              {typeof (tooltip?.title || tooltip) === 'string' && (
                <Tooltip title={tooltip?.title || tooltip}>
                  <QuestionCircleOutlined />
                </Tooltip>
              )}
            </>
          )}
          valuePropName="fileList"
          rules={rules}
        >
          <Upload
            disabled={disabled}
            beforeUpload={beforeUpload}
            listType="picture-card"
            accept={accept}
            onPreview={handlePreview}
            action={() => null}
            onChange={handleChange}
            style={style}
          >
            {!disabled && (fileList?.length || 0) < multiple ? (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>
                  Cargar
                </div>
              </div>
            ) : null}
          </Upload>
        </Form.Item>
      </Col>
      <Modal
        open={!!preview}
        title={preview?.title || 'Preview'}
        footer={null}
        onCancel={() => setPreview()}
        closeIcon={<CloseCircleOutlined />}
      >
        <img alt="example" style={{ width: '100%' }} src={preview?.src} />
      </Modal>
    </>
  );
};

PicturesWall.propTypes = {
  allowedExtensions: PropTypes.arrayOf(PropTypes.string),
  rules: PropTypes.arrayOf(PropTypes.shape({})),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  limitMB: PropTypes.number,
  multiple: PropTypes.number,
  disabled: PropTypes.bool,
  tooltip: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  style: PropTypes.shape({}),
};

PicturesWall.defaultProps = {
  allowedExtensions: [],
  rules: [],
  limitMB: 6,
  multiple: Number.MAX_SAFE_INTEGER,
  disabled: false,
  tooltip: null,
  style: null,
};

export default PicturesWall;
